import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";

export default function Services() {
  const { t } = useI18n();

  return (
    <section
      id="services"
      className="relative bg-sand-100 py-24 md:py-32 lg:py-40 overflow-hidden"
      data-testid="services-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-16 md:mb-20">
          <div className="lg:col-span-7">
            <span className="block text-[10px] md:text-[11px] tracking-[0.4em] uppercase text-gold-dark mb-7">
              — {t.services.kicker}
            </span>
            <h2
              className="font-serif font-light leading-[1.08] tracking-[-0.01em] text-4xl md:text-5xl lg:text-[58px] text-ink-900"
              data-testid="services-title"
            >
              {t.services.title}
            </h2>
          </div>
          <p className="lg:col-span-5 text-[15px] md:text-base text-ink-700 leading-[1.85] max-w-md">
            {t.services.sub}
          </p>
        </div>

        <ul className="divide-y divide-sand-200 border-t border-b border-sand-200">
          {t.services.list.map((s, i) => (
            <motion.li
              key={s.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 5) * 0.05, ease: [0.16, 1, 0.3, 1] }}
              className="group grid grid-cols-12 gap-4 md:gap-8 items-center py-8 md:py-10 cursor-default"
              data-testid={`service-card-${i}`}
            >
              <span className="col-span-2 md:col-span-1 text-[10px] tracking-[0.35em] uppercase text-gold-dark">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="col-span-10 md:col-span-5 font-serif text-2xl md:text-3xl lg:text-[36px] text-ink-900 leading-[1.15] group-hover:text-gold-dark transition-colors duration-500">
                {s.title}
              </h3>
              <p className="col-span-12 md:col-span-6 text-[14px] md:text-[15px] text-ink-500 leading-[1.75]">
                {s.desc}
              </p>
            </motion.li>
          ))}
        </ul>
      </div>
    </section>
  );
}
